<template>
  <div class="web-box web-box-width">
    <audio ref="bgAudio" id="bgAudio" autoplay="autoplay" loop="loop" preload="auto">
      <source src="../../../assets/web-firehero/common/audio/bg.ogg" />
      <source src="../../../assets/web-firehero/common/audio/bg.mp3" />
      <source src="../../../assets/web-firehero/common/audio/bg.wav" />
      你的浏览器不支持audio标签
    </audio>
    <div class="top-tool">
      <div class="lang-select-box">
        <div class="cur-selected" @click="isShowLangSelect = !isShowLangSelect">
          <span class="lang" :class="[curLang == 'zh' ? 'lang-zh' : 'lang-tw']"></span>
        </div>
        <ul class="option-list" v-if="isShowLangSelect">
          <li class="option" @click="langSwitch('zh')">
            <span class="lang lang-zh"></span>
          </li>
          <span class="option-line"></span>
          <li class="option"  @click="langSwitch('tw')">
            <span class="lang lang-tw"></span>
          </li>
        </ul>
      </div>
      <a class="fb" target="_blank" :href="toUrl.fb"></a>
      <a class="baha" target="_blank" :href="toUrl.baha"></a>
      <div class="audio-btn" :class="{'play':isPlayBgAudio}" @click="bgAudioClick"></div>
    </div>
    <div class="menu" id="menu" :style="{'background-image':cssRequireByLang('/imgs/menu.png')}">
      <a data-menuanchor="page1" class="menu-active menu1" href="#page1" :style="{'background-image':cssRequireByLang('/imgs/menu-1.png')}"></a>
      <a data-menuanchor="page2" class="menu-active menu2" href="#page2" :style="{'background-image':cssRequireByLang('/imgs/menu-2.png')}"></a>
      <a data-menuanchor="page3" class="menu-active menu3" href="#page3" :style="{'background-image':cssRequireByLang('/imgs/menu-3.png')}"></a>
      <a data-menuanchor="page4" class="menu-active menu4" href="#page4" :style="{'background-image':cssRequireByLang('/imgs/menu-4.png')}"></a>
      <a data-menuanchor="page5" class="menu-active menu5" href="#page5" :style="{'background-image':cssRequireByLang('/imgs/menu-5.png')}"></a>
    </div>
    <full-page id="fullpage" :options="options" ref="page">
      <div class="section">
        <div class="page page1">
          <div class="logo-bg" :style="{'background-image':cssRequireByLang('/imgs/bg-1-logo.png')}">
            <div class="play-btn" @click="videoClick"></div>
          </div>
          <video
            ref="page1Video"
            class="vedio-bg"
            muted="muted"
            autoplay="autoplay"
            loop
            data-keepplaying
            :poster="imgRequireByLang('/imgs/bg-1.jpg')">
            <source :src="imgRequireByLang('/vedio/bg-1.webm')"  type="video/webm">
          </video>
          <div class="reservation-box">
            <a target="_blank" class="download ios-btn " :href="toUrl.ios" @click="downClick(toUrl.ios,true)"></a>
            <a target="_blank" class="download android-btn " :href="toUrl.gp" @click="downClick(toUrl.gp,false)"></a>
            <span class="rating"></span>
          </div>
        </div>
      </div>
      <div class="section ">
        <div class="page page2">
          <div class="reward" :style="{'background-image':cssRequireByLang('/imgs/reward.png')}">
            <div class="achieved pos1" :style="{'background-image':cssRequireByLang('/imgs/achieved.png')}" v-if="rewardGrade >= 1"></div>
            <div class="achieved pos2" :style="{'background-image':cssRequireByLang('/imgs/achieved.png')}" v-if="rewardGrade >= 2"></div>
            <div class="achieved pos3" :style="{'background-image':cssRequireByLang('/imgs/achieved.png')}" v-if="rewardGrade >= 3"></div>
            <div class="achieved pos4" :style="{'background-image':cssRequireByLang('/imgs/achieved.png')}" v-if="rewardGrade >= 4"></div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="page page3">
          <div class="swiper-box">
            <swiper class="hero-swipe" ref="heroSwipe" :options="heroSwiperOptions">
              <swiper-slide class="hero-slide" v-for="(hero,index) in heroList" :key="index">
                <img class="hero"  :src="imgRequireByCommon(hero.heroBg.img)" alt="">
                <img class="info" :src="imgRequireByLang(hero.heroInfo.img)" alt="">
                <img class="cv" :src="imgRequireByLang(hero.heroCv.img)" alt="" @click="heroAudioCLick(hero.heroCvAudio)">
              </swiper-slide>
            </swiper>
            <div class="hero-swiper-navigation hero-swiper-prev" slot="button-prev"></div>
            <div class="hero-swiper-navigation hero-swiper-next" slot="button-next"></div>
          </div>
        </div>
      </div>
      <div class="section ">
        <div class="page page4">
          <div class="worldview-box" :style="{'background-image':cssRequireByLang('/imgs/bg-worldview.png')}">
            <div class="worldview-text" :style="{'background-image':cssRequireByLang('/imgs/worldview-text.png')}"></div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="page page5">
          <div class="game-feature-logo" :style="{'background-image':cssRequireByLang('/imgs/game-feature.png')}"></div>
          <div class="swiper-box">
            <swiper class="feature-swipe" ref="featureSwipe" :options="featureSwiperOptions">
              <swiper-slide class="feature-slide" v-for="(feature,index) in featureList" :key="index">
                <img :src="imgRequireByLang(feature.img)" alt="">
              </swiper-slide>
            </swiper>
            <div class="feature-swiper-navigation feature-swiper-prev" slot="button-prev"></div>
            <div class="feature-swiper-navigation feature-swiper-next" slot="button-next"></div>
          </div>
        </div>
      </div>
    </full-page>
    <audio ref="heroAudio" id="heroAudio" preload="auto">
      <source :src="heroCV.ogg" />
      <source :src="heroCV.map3" />
      <source :src="heroCV.wav" />
      你的浏览器不支持audio标签
    </audio>
    <!-- 视频弹窗 start -->
    <div class="dialog-box" v-if="isPlayVideo" @click="videoClick">
      <div class="dialog-video" @click.stop="videoStopClick">
        <video
          ref="gameVedio"
          src="../../../assets/web-firehero/common/vedio/game.mp4"
          width="100%"
          height="100%"
          autoplay="autoplay"
          controls
          preload></video>
      </div>
    </div>
    <!-- 视频弹窗 end -->
  </div>
</template>

<script>
  import * as config from '@/config';
  import * as datetool from '@/utils/date.js';
  import * as commonTool from '@/utils/common.js';
  import * as webSites from "@/api/webSites.js";
  import WebStorageCache from "web-storage-cache";
  const sessionCache = new WebStorageCache({storage: "sessionStorage"});      //sessionstorage
  // import {  Pagination, Autoplay,EffectFade } from 'swiper'
  // Swiper.use([Pagination, Autoplay,EffectFade])
  import { Swiper,SwiperSlide, directive } from 'vue-awesome-swiper'
  // Vue.use(VueAwesomeSwiper,{Pagination, Autoplay,EffectFade})

  export default {
    components: {
      Swiper,
      SwiperSlide,
    },
    directives: {
      swiper: directive
    },
    data () {
      return {
        commonTool:commonTool,
        webURL:config.FIREHERO_WEBURL,
        webType:"pc",
        curLang:commonTool.getSystemLang(),
        toUrl:{
          fb:config.FIREHERO_DOWN_URL.fb,
          baha:config.FIREHERO_DOWN_URL.baha,
          ios:config.FIREHERO_DOWN_URL.ios,
          gp:config.FIREHERO_DOWN_URL.gp,
        },
        heroList:config.FIREHERO_WEBSITE_CONFIG.heroList,
        featureList:config.FIREHERO_WEBSITE_CONFIG.featureList,
        isPlayVideo:false,
        isShowLangSelect:false,
        isPlayBgAudio:false,
        heroCV:{
          ogg:"",
          map3:"",
          wav:"",
        },
        rewardGrade:0,//预约奖励档次
        videoUrl:"../../../assets/web-firehero/common/vedio/game.mp4",
        featureSwiperOptions: {
          watchSlidesProgress: true,
          slidesPerView: 3,
          speed:1000,
          centeredSlides:true,
          loop: true,
          loopedSlides: 3,
          autoplay: true,
          navigation: {
            nextEl: '.feature-swiper-next',
            prevEl: '.feature-swiper-prev'
          },
          on: {}
        },
        heroSwiperOptions: {
          effect : 'fade',
          fadeEffect: {
            crossFade: true,
          },
          slidesPerView: 1,
          speed:1000,
          centeredSlides:true,
          loop: true,
          loopedSlides: 1,
          autoplay: true,
          navigation: {
            nextEl: '.hero-swiper-next',
            prevEl: '.hero-swiper-prev'
          },
          on: {
          }
        },
        options: {
          // 为每个section设置背景色
          //sectionsColor: ["#f00","#0f0","#00f"],
          //用来控制slide幻灯片的箭头，设置为false，两侧的箭头会消失
          //controlArrows: false,
          //每一页幻灯片的内容是否垂直居中
          //verticalCentered: false,
          //字体是否随着窗口缩放而缩放
          //resize: true,
          //页面滚动速度
          //scrollingSpeed: 700,
          //定义锚链接，用户可以快速打开定位到某一页面；不需要加"#"，不要和页面中任意的id和name相同
          //anchors: ["page1","page2","page3"],
          //是否锁定锚链接
          //lockAnchors: true,
          //定义section页面的滚动方式，需要引入jquery.easings插件
          //easing:,
          //是否使用css3 transform来实现滚动效果
          // css3: true,
          //滚动到最顶部后是否连续滚动到底部
          //loopTop: true,
          //滚动到最底部后是否连续滚动到顶部
          //loopBottom: true,
          //横向slide幻灯片是否循环滚动
          //loopHorizontal: false,
          //是否循环滚动，不会出现跳动，效果很平滑
          //continuousVertical: true,
          //是否使用插件滚动方式，设为false后，会出现浏览器自带的滚动条，将不会按页滚动
          //autoScrolling: false,
          //是否包含滚动条，设为true，则浏览器自带的滚动条会出现，页面还是按页滚动，但是浏览器滚动条默认行为也有效
          //scrollBar: true,
          //设置每个section顶部的padding，当我们要设置一个固定在顶部的菜单、导航、元素等时使用
          //paddingTop: "100px",
          //设置每个section底部的padding，当我们要设置一个固定在底部的菜单、导航、元素等时使用
          //paddingBottom: "100px",
          //固定的元素，为jquery选择器；可用于顶部导航等
          //fixedElements: ".nav",
          //是否可以使用键盘方向键导航
          //keyboardScrolling: false,
          //在移动设置中页面敏感性，最大为100，越大越难滑动
          //touchSensitivity: 5,
          //设为false，则通过锚链接定位到某个页面不再有动画效果
          //animateAnchor: false,
          //是否记录历史，可以通过浏览器的前进后退来导航
          //recordHistory: true,
          //绑定菜单，设定相关属性和anchors的值对应后，菜单可以控制幻灯片滚动
          //menu: '.nav',
          //是否显示导航，设为true会显示小圆点作为导航
          //navigation: true,
          //导航小圆点的位置，可以设置为left或者right
          //navigationPosition: right,
          //鼠标移动到小圆点上时显示出的提示信息
          //navigationTooltips: ["第一页","第二页","第三页"],
          //是否显示当前页面小圆点导航的提示信息，不需要鼠标移上
          //showActiveTooltip: true,
          //是否显示横向幻灯片的导航
          //slidesNavigation: true,
          //横向幻灯片导航的位置，可以为top或者bottom
          //slidesNavPosition: bottom,
          //内容超过满屏时是否显示滚动条，需要jquery.slimscroll插件
          //scrollOverflow: true,
          //section选择器
          //sectionSelector: ".section",
          //slide选择器
          //slideSelector: ".slide"
          licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
          afterLoad: this.onAfterLoad,
          onLeave: this.onLeave, //滚动前的回调函数，
          scrollOverflow: true,
          navigation: false, //是否显示导航，默认为false
          navigationPosition: 'right', //导航小圆点的位置
          scrollBar: false,
          keyboardScrolling: false, //是否可以使用键盘方向键导航，默认为true
          continuousVertical: false, /// 是否循环滚动，默认为false。如果设置为true，则页面会循环滚动，而不像loopTop或loopBottom那样出现跳动，注意这个属性和loopTop、loopBottom不兼容和，不要同时设置
          menu: '#menu',
          // navigation: true,
          anchors: ['page1', 'page2', 'page3', 'page4', 'page5'],
          lockAnchors: true,
          sectionsColor: []
        }
      }
    },
    watch: {
    },
    computed: {
      heroSwipe() {
        return this.$refs.heroSwipe.$swiper
      },
      featureSwipe() {
        return this.$refs.featureSwipe.$swiper
      },
    },
    created() {
      let that = this;
      if (!that.commonTool.isPC()) {
        that.$router.push('/web/firehero/h5');
      }
    },
    mounted () {
      let that = this;
      let params = {};
      webSites.getRewardByFirehero(params,that.webURL).then(res => {
        let data = res.data;
        if (data.ret === 0 ) {
          that.rewardGrade = data.reward;
        }else {
          that.$toast("error !!!");
        }
      })
    },
    methods: {
      imgRequireByCommon(value){
        return require("../../../assets/web-firehero/common/" + this.webType + value);
      },
      cssRequireByCommon(value){
        return "url(" + this.imgRequireByCommon(value) + ")";
      },
      imgRequireByLang(value){
        return require("../../../assets/web-firehero/" + this.curLang + "/" + this.webType + value);
      },
      cssRequireByLang(value){
        return "url(" + this.imgRequireByLang(value) + ")";
      },
      langSwitch(lang){
        this.isShowLangSelect = false;
        this.curLang = lang;
        this.$refs.page1Video.load();
      },
      bgAudioClick(){
        if (this.isPlayBgAudio) {
          this.$refs.bgAudio.pause();
          this.isPlayBgAudio = false;
        }else {
          this.$refs.bgAudio.play();
          this.isPlayBgAudio = true;
        }
      },
      heroAudioCLick (cv) {
        let that = this;
        this.heroCV.ogg = require("../../../assets/web-firehero/common/audio/" + cv + ".ogg");
        this.heroCV.map3 = require("../../../assets/web-firehero/common/audio/" + cv + ".mp3");
        this.heroCV.wav = require("../../../assets/web-firehero/common/audio/" + cv + ".wav");
        this.$refs.heroAudio.load();
        this.$refs.heroAudio.play();
        this.heroSwipe.autoplay.stop();
        this.$refs.heroAudio.onended = function() {
          that.heroSwipe.autoplay.start();
        };
      },
      videoClick(){
        let that = this;
        if(that.isPlayVideo){
          that.isPlayVideo = false;
          if (this.isPlayBgAudio) {
            this.$refs.bgAudio.play();
          }
        }else {
          that.isPlayVideo = true;
          this.$refs.bgAudio.pause();
        }
      },
      videoStopClick(){
        console.log('')
      },
      onAfterLoad(index, nextIndex, direction){
      },
      onLeave(index, nextIndex, direction){
        // console.log(index)
        // console.log(nextIndex)
        // console.log(direction)
      },
      prev() {
        this.featureSwipe.slidePrev();
      },
      next() {
        this.featureSwipe.slideNext();
      },
      //下载链接跳转点击事件
      downClick(url,isIOS){
        let that = this;
        that.openUrl(url);
      },
      //gp跟踪代码
      gpClick(url,isIOS){
        let that = this;
        gtag('event', 'conversion', {
          'send_to': 'AW-355221226/kEd4CNSt9ssCEOr9sKkB',
          'event_callback': that.openUrl(url)
        });
      },
      //fb像素代码
      fbPixelClick(url,isIOS){
        fbq('track', 'CompleteRegistration');
        this.openUrl(url);
      },
      openUrl (url) {
        window.open(url, '_blank');
      }
    },
  }
</script>

<style scoped>
.web-box{
  position: relative;
  overflow: hidden;
  min-width: 1080px;
  width: 100%;
  height: 100%;
}

.web-box .top-tool{
  position: absolute;
  z-index: 100;
  width: 20%;
  min-width: calc(1080px * 0.2);
  padding-top: calc(2.2% * (40 / 40));
  top:2%;
  left: 73%;
}

.web-box .top-tool .lang-select-box{
  position: absolute;
  width: 25%;
  height: 100%;
  top: 0%;
  right: 95%;
  line-height:100%;
}


.web-box .top-tool .lang-select-box .lang {
  display: block;
  position: relative;
  top: 25%;
  width: 40%;
  padding-top: calc(40% * (20 / 40));
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
  transform: translate(-50%);
  left: 50%;
}

.web-box .top-tool .lang-select-box .lang.lang-zh {
  background-image: url('../../../assets/web-firehero/common/pc/imgs/lang-zh.png');
}

.web-box .top-tool .lang-select-box .lang.lang-tw {
  background-image: url('../../../assets/web-firehero/common/pc/imgs/lang-tw.png');
}

.web-box .top-tool .lang-select-box .cur-selected{
  width: 100%;
  height: 100%;
  background-image: url('../../../assets/web-firehero/common/pc/imgs/bg-lang.png');
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
  cursor: pointer;
}

.web-box .top-tool .lang-select-box .cur-selected .lang{
  left: 40%;

}

.web-box .top-tool .lang-select-box .option-list{
  width: 100%;
  height: calc(100% * 1.8);
  border-radius: 10%;
  /*padding-top: calc(100% * (103 / 60));*/
  background-image: url('../../../assets/web-firehero/common/pc/imgs/bg-option.png');
  background-size: cover;
  background-position: 0%;
  background-repeat: no-repeat;
}
.web-box .top-tool .lang-select-box .option-list .option{
  width: 100%;
  height: 50%;
  cursor: pointer;
}

.web-box .top-tool .lang-select-box .option-list .option-line{
  display: block;
  width: 80%;
  height: 1%;
  margin: auto;
  background-color: #c7b6a3;
}

.web-box .top-tool .fb{
  position: absolute;
  cursor: pointer;
  width: 35%;
  padding-top: calc(35% * (53 / 172));
  top: 0%;
  right: 55%;
  background-image: url('../../../assets/web-firehero/common/pc/imgs/facebook.png');
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
}

.web-box .top-tool .baha{
  position: absolute;
  cursor: pointer;
  width: 35%;
  padding-top: calc(35% * (53 / 172));
  top: 0%;
  right: 18%;
  background-image: url('../../../assets/web-firehero/common/pc/imgs/baha.png');
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
}

.web-box .top-tool .baha:after{
  position: absolute;
  content: "";
  cursor: auto;
  width: 2%;
  top: 20%;
  right: -10%;
  padding-top: calc(15% * (40 / 39));
  background-color: #f3f3f3;
}

.web-box .top-tool .audio-btn{
  position: absolute;
  cursor: pointer;
  width: 12%;
  padding-top: calc(12% * (72 / 76));
  top: 0%;
  right: 0%;
  background-image: url('../../../assets/web-firehero/common/audio/noplay.png');
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
}

.web-box .top-tool .audio-btn.play{
  background-image: url('../../../assets/web-firehero/common/audio/play.png');
}

.web-box .menu{
  position: absolute;
  z-index: 100;
  width: 6%;
  min-width: calc(1080px * (114 / 1920));
  padding-top: calc(6% * (860 / 114));
  /*background-image: url('../../../assets/web-firehero/zh/pc/imgs/menu.png');*/
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
  top:10%;
  left: 90%;
}

.web-box .menu .menu-active{
  position: absolute;
  z-index: 101;
  width:100%;
  padding-top: calc(100% * (126 / 114));
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
  cursor: pointer;
  opacity: 0;
}

.web-box .menu .menu-active.menu1{
  top:12.6%;
  background-image: url('../../../assets/web-firehero/zh/pc/imgs/menu-1.png');
}

.web-box .menu .menu-active.menu2{
  top:27.6%;
  background-image: url('../../../assets/web-firehero/zh/pc/imgs/menu-2.png');
}

.web-box .menu .menu-active.menu3{
  top:43%;
  background-image: url('../../../assets/web-firehero/zh/pc/imgs/menu-3.png');
}

.web-box .menu .menu-active.menu4{
  top:58.2%;
  background-image: url('../../../assets/web-firehero/zh/pc/imgs/menu-4.png');
}

.web-box .menu .menu-active.menu5{
  top:73.1%;
  background-image: url('../../../assets/web-firehero/zh/pc/imgs/menu-5.png');
}

.web-box .menu .menu-active.active{
  opacity: 1;
}

.page {
  position: relative;
  width:100vw;
  min-width: 1080px;
  /*height: calc(100vw * (1080 / 1920));*/
  min-height: calc(1080px * (1080 / 1920));
  overflow: hidden;
  background-size: cover;
  background-position: top left;
  background-repeat: no-repeat;
}

.page1 .vedio-bg {
  width: calc(100vh * (1920 / 1080));
  min-width: 100%;
  min-height: 100vh;
}

.page1 .logo-bg {
  position: absolute;
  z-index: 1;
  width: 38%;
  padding-top: calc(38% * (333 / 574));
  background-image: url('../../../assets/web-firehero/zh/pc/imgs/bg-1-logo.png');
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
  left: 36%;
  top: 3%;
}

.page1 .logo-bg .play-btn {
  position: absolute;
  z-index: 2;
  width: 10%;
  padding-top: 10%;
  background-image: url('../../../assets/web-firehero/common/pc/imgs/play-btn.png');
  background-size: cover;
  left: 75%;
  top: 76%;
  cursor: pointer;
}

.page1 .reservation-box {
  position: absolute;
  z-index: 1;
  width: 29%;
  padding-top: calc(29% * (80 / (267/0.45)));;
  left: 8.5%;
  top: 70%;
}

.page1 .reservation-box .rating{
  position: absolute;
  z-index: 2;
  width: 14%;
  padding-top: calc(14% * (621 / 620));
  top: 0;
  background-size: 100% 100%;
  cursor: pointer;
  -webkit-transition: opacity .2s;
  transition: opacity .2s;
  left: -10%;
  background-image: url('../../../assets/web-firehero/common/game-rating.jpeg');
}

.page1 .reservation-box .download{
  position: absolute;
  z-index: 2;
  width: 45%;
  padding-top: calc(45% * (80 / 267));
  top: 0;
  background-size: 100% 100%;
  cursor: pointer;
  -webkit-transition: opacity .2s;
  transition: opacity .2s;
}
.page1 .reservation-box .download.ios-btn{
  left: 10%;
  background-image: url('../../../assets/web-firehero/zh/pc/imgs/ios-btn.png');
}
.page1 .reservation-box .download.android-btn{
  left: 65%;
  background-image: url('../../../assets/web-firehero/zh/pc/imgs/android-btn.png');
}

.page2{
  width: 100%;
  height: 100%;
  background-image: url('../../../assets/web-firehero/common/pc/imgs/bg-2.jpg');
}

.page2 .reward{
  position: absolute;
  z-index: 1;
  width: 55%;
  padding-top: calc(55% * (938 / 1054));
  top: 6.3%;
  left: 0.5%;
  background-image: url('../../../assets/web-firehero/zh/pc/imgs/reward.png');
  background-size: cover;
  background-position: top left;
  background-repeat: no-repeat;
}

.page2 .reward .achieved{
  position: absolute;
  z-index: 2;
  width: 14%;
  height:  calc(15% * (140 / 151));
  background-image: url('../../../assets/web-firehero/zh/pc/imgs/achieved.png');
  background-size: cover;
  background-position: top left;
  background-repeat: no-repeat;
  top: 78.5%;
}

.page2 .reward .achieved.pos1{
  left: 6%;
}

.page2 .reward .achieved.pos2{
  left: 30%;
}

.page2 .reward .achieved.pos3{
  left: 54.5%;
}

.page2 .reward .achieved.pos4{
  left: 79%;
}

.page3{
  width: 100%;
  height: 100%;
  background-image: url('../../../assets/web-firehero/common/pc/imgs/bg-3.jpg');
}

.page3 .swiper-box{
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
}

.page3 .swiper-box .hero-swipe{
  width: 100%;
  height: 100%;
}

.page3 .swiper-box .hero-swipe .hero-slide .hero{
  position: absolute;
  z-index: 2;
  width: 100%;
  top: 0;
  left: 0;
}

.page3 .swiper-box .hero-swipe .hero-slide .info{
  position: absolute;
  z-index: 4;
  width: 30%;
  top: 2%;
  right: 17%;
}

.page3 .swiper-box .hero-swipe .hero-slide .cv{
  position: absolute;
  z-index: 2;
  width: 20%;
  top: 82.5%;
  left: 6.1%;
  cursor: pointer;
}

.page3 .swiper-box .hero-swipe .hero-slide.swiper-slide-active .cv{
}


.page3 .hero-swiper-navigation {
  position: absolute;
  z-index: 5;
  width: 8%;
  padding-top: calc(8% * (85 / 125));
  margin-top: 25.5%;
  top:0%;
  background-image: url('../../../assets/web-firehero/common/pc/imgs/hero-navigation.png');
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
  cursor: pointer;
}

.page3 .hero-swiper-navigation.hero-swiper-prev{
  left: 4%;
}

.page3 .hero-swiper-navigation.hero-swiper-next{
  right: 10%;
  transform: rotate(180deg);
}

.page4{
  width: 100%;
  height: 100%;
  background-image: url('../../../assets/web-firehero/common/pc/imgs/bg-4.jpg');
}

.page4 .worldview-box{
  position: absolute;
  z-index: 1;
  width: 79%;
  padding-top: calc(79% * (1001 / 1521));
  top: 5.5%;
  left: 2.8%;
  background-image: url('../../../assets/web-firehero/zh/pc/imgs/bg-worldview.png');
  background-size: cover;
  background-position: top left;
  background-repeat: no-repeat;
}

@keyframes worldview-show{
  from {padding-top: 0;}
  to {padding-top: calc(25% * (531 / 382));}
}

.page4 .worldview-box .worldview-text{
  position: absolute;
  z-index: 2;
  width: 25%;
  padding-top: calc(25% * (531 / 382));
  top: 32%;
  left: 12.5%;
  background-image: url('../../../assets/web-firehero/zh/pc/imgs/worldview-text.png');
  background-size: cover;
  background-position: top left;
  background-repeat: no-repeat;
  animation: worldview-show 5s linear;
}

.page5{
  width: 100%;
  height: 100%;
  background-image: url('../../../assets/web-firehero/common/pc/imgs/bg-5.jpg');
}

.page5 .game-feature-logo{
  position: absolute;
  z-index: 1;
  width: 21%;
  padding-top: calc(21% * (147 / 431));
  background-image: url('../../../assets/web-firehero/zh/pc/imgs/game-feature.png');
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
  left: 39.5%;
  top: 8%;
}

.page5 .swiper-box{
  position: absolute;
  /*width: 22%;*/
  /*padding-top: calc(22% * (727 / 409));*/
  width: 70%;
  padding-top: calc(70% * 0.55);
  top: 21%;
  left: 15%;
}

.page5 .swiper-box .feature-swipe{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.page5 .swiper-box .feature-swipe .feature-slide{
  width: 30%;
  height: 100%;
  top: 0;
  left: 0;
  transform: scale(0.8);
}

.page5 .feature-swipe .feature-slide img{
  position: relative;
  width: 100%;
  height: 100%;
  margin: auto;
  display:block;
}

.page5 .feature-swipe .feature-slide:after{
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 90;
}

.page5 .feature-swipe .feature-slide.swiper-slide-active:after{
  background-color: rgba(0, 0, 0, 0);
}

.page5 .feature-swipe .feature-slide.swiper-slide-active{
  z-index: 99;
  transform: scale(1);
  transition-duration: 500ms;
}

.page5 .feature-swipe .feature-slide.swiper-slide-prev{
  z-index: 88;
  transform: scale(0.8);
  transition-duration: 500ms;
}

.page5 .feature-swipe .feature-slide.swiper-slide-next{
  z-index: 88;
  transform:  scale(0.8);
  transition-duration: 500ms;
}

.page5 .feature-swiper-navigation {
  position: absolute;
  z-index: 1;
  width: 6%;
  padding-top: calc(15% * (89 / 65));
  margin-top: 15.74236%;
  top:0%;
  background-image: url('../../../assets/web-firehero/common/pc/imgs/feature-navigation.png');
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
  cursor: pointer;
}

.page5 .feature-swiper-navigation.feature-swiper-prev{
  right: 100%;
  transform: rotate(180deg);
}

.page5 .feature-swiper-navigation.feature-swiper-next{
  left: 100%;
}

.dialog-box{
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  opacity: 1;
  background: rgba(0,0,0,0.7);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000,endColorstr=#99000000);
  transform: translate3d(0,0,1px);
  -webkit-transform: translate3d(0,0,1px);
}

/*视频弹窗*/
.dialog-box .dialog-video{
  position: relative; /*脱离文档流*/
  top: 12.5%; /*偏移*/
  margin:auto;
  width: 75%;
  height: 75%;
}
</style>



// WEBPACK FOOTER //
// src/pages/website/firehero/index.vue